export { default } from './responsivePosition'
